export default "precision highp float;\nprecision highp int;\nvarying vec4 color;\nuniform vec2 resolution;\n\nvoid main() { gl_FragColor = color; }";